// Import the RTK Query methods from the React-specific entry point
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import Persist, { StorageKind } from 'lib/persist';
import { PromoEngineResponseApi } from 'lib/promoEngine/types';

const localStorage = Persist(StorageKind.local);

// Define our single API slice object
export const promoEngineApiSlice = createApi({
  // The cache reducer expects to be added at `state.api` (already default - this is optional)
  reducerPath: 'api_promo_engine',
  // All of our requests will have URLs starting with '/fakeApi'
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_PROMO_ENGINE}`,
    credentials: 'same-origin',
    prepareHeaders: (headers) => {
      const accessToken = localStorage.getItem('token');
      if (accessToken) {
        headers.set('authorization', `Bearer ${accessToken}`);
        headers.set('Content-Type', 'application/json');
      }
      return headers;
    },
  }),
  // The "endpoints" represent operations and requests for this server
  endpoints: (builder) => ({
    // The `getPosts` endpoint is a "query" operation that returns data
    getPageBanners: builder.query<PromoEngineResponseApi | undefined, string>({
      query: (id) => `/pages/${id}`,
    }),
  }),
});

// Export the auto-generated hook for the `getPosts` query endpoint
export const { useGetPageBannersQuery } = promoEngineApiSlice;

/*
export const useGetPageBannersQuery = (id : string, params?:{}) : {data:PromoEngineResponseApi, isLoading: boolean, isError: boolean, isUninitialized : boolean}=> { 
  console.log(`useGetPageBannersQuery(${id})`)
  return ({
    isUninitialized: true,
    isLoading : false,
    isError : false,
    data:
  {
    "heroBannerList": [
         {
            "id": "3cc643ec-e8b6-41c7-f54a-08db98c6e34f",
            "backgroundPattern": "B",
            "backgroundColor": "#2da7ff",
            "isPromo": true,
            "title": "1.000€ in Bonus",
            "subtitle": "Sul giocato delle tue singole Live",
            "cta": {
                "label": "SCOPRI",
                "url": "https://snai.it/promozioni?id_promo=1985"
            },
            "bannerType": [
                "Landscape"
            ],
            "images": {
                "landscape": {
                    "srcDesktop": "https://content.snai.it/prod/afdb4c8c631d463a95c59ed8b07e7242.png",
                    "srcMobile": null
                },
                "portrait": null,
                "alt": "SCOPRI"
            }
        } , 
        {
            "id": "5f56a366-ed44-481d-f549-08db98c6e34f",
            "backgroundPattern": "A",
            "backgroundColor": "#2da7ff",
            "isPromo": true,
            "title": "40.000€ Bonus",
            "subtitle": "Partecipa alla classifica dedicata al Tennis",
            "cta": {
                "label": "Scopri",
                "url": "https://snai.it/promozioni?id_promo=1938"
            },
            "bannerType": [
                "Landscape"
            ],
            "images": {
                "landscape": {
                    "srcDesktop": "https://content.snai.it/prod/5428d4840c6d4731b139c8285c2c9c6c.png",
                    "srcMobile": "https://content.snai.it/prod/9ed9ef82102343248a7e47813faab486.png"
                },
                "portrait": null,
                "alt": "Scopri"
            }
        },
      ],
    "portraitBanner": null,
    "pageBannerList": []
  } as unknown as PromoEngineResponseApi})
}
*/
